import {reducer} from '../helpers'

import * as lookbuilderActions from '../../actions/lookbuilder'
import {ApiRequestStates} from '../../const'

const initialState = {
  currentCategory: '',
  previousCategory: '',
  productsBySlug: {},
  fetchProductsByCategoryStatus: ApiRequestStates.IDLE,
  allProductSlugs: [],
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case lookbuilderActions.RESET_LOOKBUILDER_LOOK:
      return {...initialState}
    case lookbuilderActions.OPEN_LOOKBUILDER_CATEGORY_VIEW:
      return {
        ...state,
        currentCategory: payload.category,
        previousCategory: state.currentCategory,
      }
    case lookbuilderActions.GET_PRODUCTS_BY_CATEGORY_PENDING:
      return {
        ...state,
        fetchProductsByCategoryStatus: ApiRequestStates.PENDING,
      }
    case lookbuilderActions.GET_PRODUCTS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchProductsByCategoryStatus: ApiRequestStates.SUCCESS,
        productsBySlug: payload.productsBySlug,
        allProductSlugs: payload.allProductSlugs,
      }
    case lookbuilderActions.GET_PRODUCTS_BY_CATEGORY_FAILURE:
      return {
        ...state,
        fetchProductsByCategoryStatus: ApiRequestStates.ERROR,
      }
    default:
      return null
  }
})
